// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"Landing_bannerContainer__2vXfl","main":"Landing_main__y5Tp5","header":"Landing_header__3MNgY"};